import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui";
import { CheckCircle2 } from "lucide-react";
import { trackSignupConversion } from "@/lib/attribution";

// Distinct completion URL (/signup/success) so Ads/GA4 get a real page load for
// the conversion. Fires the conversion on mount too (one-shot guarded) as a
// belt-and-suspenders alongside the fire in the signup handler.
export default function SignupSuccess() {
  const navigate = useNavigate();
  useEffect(() => { trackSignupConversion(); }, []);
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface p-6">
      <div className="w-full max-w-md text-center kb-fade-up">
        <Logo className="h-9 mx-auto" testid="brand-name" />
        <div className="w-14 h-14 rounded-full bg-mint-tint flex items-center justify-center mx-auto mt-8">
          <CheckCircle2 className="w-8 h-8 text-mint-dark" />
        </div>
        <h1 className="font-display text-3xl text-ink mt-5" data-testid="signup-success-title">Your account is ready</h1>
        <p className="text-subtle mt-2">Next, let&apos;s set up your care circle — it only takes a minute.</p>
        <Button className="mt-6 w-full" data-testid="signup-success-continue" onClick={() => navigate("/onboarding", { replace: true })}>
          Continue to setup
        </Button>
      </div>
    </div>
  );
}
